import React from "react"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"

import asyncActions from "../../../state/async-actions"
import * as actions from "../../../state/actions"

import ReactResizeDetector from "react-resize-detector"

import { createVega } from "./vegaUtils"

import "./HKVVega.css"

class HKVVega extends React.Component {
  constructor(props) {
    super(props)

    this.vegaRef = React.createRef()

    this.state = {}

    const { config, t } = this.props

    const locale = {
      dateTime: "%a %e %B %Y %T",
      date: "%d-%m-%Y",
      time: "%H:%M:%S",
      periods: ["AM", "PM"],
      days: [t("sunday"), t("monday"), t("tuesday"), t("wednesday"), t("thursday"), t("friday"), t("saturday")],
      shortDays: [t("shortsunday"), t("shortmonday"), t("shorttuesday"), t("shortwednesday"), t("shortthursday"), t("shortfriday"), t("shortsaturday")],
      months: [t("january"), t("february"), t("march"), t("april"), t("may"), t("june"), t("july"), t("august"), t("september"), t("october"), t("november"), t("december")],
      shortMonths: [t("jan"), t("feb"), t("mar"), t("apr"), t("may"), t("jun"), t("jul"), t("aug"), t("sep"), t("oct"), t("nov"), t("dec")]
    }

    // this.props.dispatch(asyncActions.setLoader(this.props.database.loading + 1))
    //   .then(() => {
    let file = config.specName
    let local = true

    if (config.specUrl) {
      file = config.specUrl
      local = false
    }

    if (file) {
      this.props.dispatch(asyncActions.getVegaSpec(file, local))
        .then((spec) => {
          this.setState({ fetchedSpec: spec }, () => {
            createVega(this.vegaRef.current, spec, this.vegaDidMount, config, locale)
            // this.props.dispatch(asyncActions.setLoader(this.props.database.loading - 1))
          })
        })
    } else {
      this.props.dispatch({ type: actions.SET_ERROR, error: { message: "Er is geen vega spec-name/ url meegegeven", type: "error", duration: 4000 } })
      // this.props.dispatch(asyncActions.setLoader(this.props.database.loading - 1))
    }
    // })
  }

  vegaDidMount = (viewObject, key) => {
    const { config, vegaDidMount } = this.props
    const { initialSizes } = this.state

    this.viewObject = viewObject

    // Als vega is "gemount" run de handleResize
    if (initialSizes) {
      this.handleResize(viewObject, initialSizes.width, initialSizes.height)
    } else {
      const element = document.getElementById(`vega-container-${config.key}`)
      this.handleResize(viewObject, element.offsetWidth, element.offsetHeight)
    }

    vegaDidMount(viewObject, key)
  }

  handleResize = (viewObject, width, height) => {
    // Als er nog geen vega viewObject is gemount, zet de size in state zodat we deze na de mount kunnen gebruiken
    if (!viewObject) {
      this.setState({ initialSizes: { width: width, height: height } })
    }

    this.props.dispatch(asyncActions.sendSignal(viewObject, { signalName: "width", value: width }))
    this.props.dispatch(asyncActions.sendSignal(viewObject, { signalName: "height", value: height }))
  }

  render() {
    const { config } = this.props
    const { fetchedSpec } = this.state

    if (!fetchedSpec) return null

    return (
      <ReactResizeDetector onResize={(width, height) => this.handleResize(this.viewObject, width, height)}>
        <div ref={this.vegaRef} id={`vega-container-${config.key}`} style={{ width: "100%", height: "100%" }} />
      </ReactResizeDetector>
    )
  }
}

HKVVega = withTranslation("translation")(HKVVega)
export default connect(state => state)(HKVVega)
